/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function getUserNotifications(userId) {
  const result = request(
    `${REACT_APP_API_BASE_URL_NEW}/api/notification-service/user-notification-settings/${userId}`,
    {
      method: "GET",
    },
  );

  return (await result).data;
}

export async function setUserNotifications(settingsId, data) {
  const result = request(
    `${REACT_APP_API_BASE_URL_NEW}/api/notification-service/user-notification-settings/${settingsId}`,
    {
      method: "PUT",
      data,
    },
  );

  return (await result).data;
}
